import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import EnrichAudiencesImage from './EnrichAudiencesImage'

const copy = {
  badge: `Coming Soon`,
  title: `Enrich audiences with data from your warehouse or lakehouse`,
  description: `Easily build powerful audiences directly from data in your data warehouse or lakehouse with an easy-to-use audience builder.`,
  list: [
    {
      title: `Unlock the power of your data with low-copy architecture`,
      description: `Linked Audiences lets you craft flexible segments for more targeted marketing efforts. You gain direct access to your data, enabling the construction of precise audience groups for immediate activation in your marketing tools without relying heavily on data teams.`,
    },
    {
      title: `Enable marketers with the data they need`,
      description: `Leverage the power of Linked Audiences to increase your targeting accuracy and boost campaign outcomes across a variety of marketing channels, including ads, emails, SMS, and beyond. Embrace the future of personalized marketing with data driven precision using Linked Audiences.`,
    },
  ],
}

const EnrichAudiences = () => {
  return (
    <SectionBase sticky={true} variant="2Col">
      <Section.Contents>
        <Section.Sticky>
          <EnrichAudiencesImage />
        </Section.Sticky>
      </Section.Contents>
      <Section.Copy>
        <CopyText.BadgeWrapper>
          <CopyText.Badge variant="filledBlue">{copy.badge}</CopyText.Badge>
        </CopyText.BadgeWrapper>
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.title}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <StyledColumnTrack>
            {copy.list.map(({ title, description }, key) => (
              <CopyTextBase key={key}>
                <CopyText.Heading tag="h3" variant="h5">
                  {title}
                </CopyText.Heading>
                <CopyText.Description tag="p" variant="pMedium">
                  {description}
                </CopyText.Description>
              </CopyTextBase>
            ))}
          </StyledColumnTrack>
        </CopyTextBase>
      </Section.Copy>
    </SectionBase>
  )
}

const StyledColumnTrack = styled(ColumnTrack)`
  margin-top: 48px;
`

export default EnrichAudiences
